__turbopack_context__.v({
  "inputSpinner": "InputSpinner-module___MAwOa__inputSpinner",
});
